import { Controller } from '@hotwired/stimulus'

// El form de edición de blogs exige al menos un autor (el campo de nicks lleva `required`).
// Pero un blog de partner/broker no tiene autor de Rankia y aun así debe poder marcarse como
// Borrado (soft-delete). Cuando el Estado pasa a Borrado quitamos el `required` del campo de
// autores para que el navegador no bloquee el envío; al volver a Activo/Blogger lo reponemos.
// El backend sigue exigiendo autor para los blogs no borrados (Blog#requerir_usuarios), así
// que esto es progressive enhancement: sin JS el form sigue siendo válido para el caso común.
//
// Targets:
//   - estado: el <select> de estado_id
//   - autores: el input de nicks de autores (#lista_autores)
// Values:
//   - borrado: valor de Blog::ESTADO_BORRADO (para no hardcodear el -1 en JS)
export default class extends Controller {
  static targets = ['estado', 'autores']
  static values = { borrado: String }

  connect () {
    this.toggle()
  }

  toggle () {
    if (!this.hasEstadoTarget || !this.hasAutoresTarget) return

    this.autoresTarget.required = this.estadoTarget.value !== this.borradoValue
  }
}
